export const cuboidMotionCompensated = `
vec3 getCuboidMotionCompensatedPosition(vec3 h3Position) {
  vec4 vertexPosition = modelMatrix * vec4(h3Position, 1.0);
  vec4 offsetPosition = vertexPosition + vec4(offset, 0.0);
  // Return the position to the local coordinates for next shaders
  vec4 localPosition = inverse(modelMatrix) * offsetPosition;
  localPosition = localPosition / localPosition.w;
  
  return vec3(localPosition); 
}
`;
